import { z } from 'zod';
export const userRoleSchema = z.enum(['admin', 'staff']);
/**
 * Resolve a stored role into one we can reason about.
 *
 * The column is nullable because better-auth's schema treats it as optional.
 * Anything unrecognized — null, empty, or a value some future library version
 * decides to write — resolves to 'staff'. Failing closed matters here: the only
 * thing on the other side of this check is who can create accounts and see the
 * audit trail, so an unreadable role must never read as privileged.
 */
export function normalizeRole(role) {
    return userRoleSchema.safeParse(role).success ? role : 'staff';
}
export function isAdmin(role) {
    return normalizeRole(role) === 'admin';
}
/** Shape of the signed-in user handed to the frontend. Never includes a hash. */
export const sessionUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    role: userRoleSchema,
});
//# sourceMappingURL=user.js.map